import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { ArrowRight, Menu, X } from "lucide-react";
import { FoxMark, Wordmark } from "@/components/Logo";
import { useAuth } from "@/lib/auth";

export const NAV = [
    { to: "/wp-recipe-maker", label: "WP Recipe Maker" },
    { to: "/wp-delicious", label: "WP Delicious" },
    { to: "/recipe-listicles", label: "Listicles" },
    { to: "/recipefox-vs-chatgpt", label: "vs ChatGPT" },
    { to: "/pricing", label: "Pricing" },
    { to: "/guides", label: "Guides" },
];

const linkCls = ({ isActive }) =>
    `px-3 py-2 text-sm transition-colors hover:text-klein ${isActive ? "text-klein" : "text-ink"}`;

export default function PublicHeader() {
    const { user } = useAuth();
    const [open, setOpen] = useState(false);
    return (
        <header className="border-b border-line bg-white/85 backdrop-blur-md sticky top-0 z-40" data-testid="public-header">
            <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between gap-4">
                <Link to="/" className="flex items-center gap-3 shrink-0" data-testid="public-header-brand">
                    <FoxMark size={30} color="#111111" />
                    <Wordmark className="text-base" />
                </Link>
                <nav className="hidden lg:flex items-center" data-testid="public-header-nav" aria-label="Main">
                    {NAV.map(n => <NavLink key={n.to} to={n.to} className={linkCls} data-testid={`nav-${n.to.slice(1)}`}>{n.label}</NavLink>)}
                </nav>
                <div className="flex items-center gap-2">
                    {user ? (
                        <Link to="/generate" className="px-4 py-2 text-sm bg-klein text-white hover:bg-kleinDark inline-flex items-center gap-2" data-testid="landing-open-app">
                            Open app <ArrowRight className="w-4 h-4" />
                        </Link>
                    ) : (
                        <>
                            <Link to="/login" className="hidden sm:inline-block px-3 py-2 text-sm hover:text-klein" data-testid="landing-login">Sign in</Link>
                            <Link to="/register" className="px-4 py-2 text-sm bg-ink text-white hover:bg-black" data-testid="landing-register">Start free</Link>
                        </>
                    )}
                    <button className="lg:hidden p-2" onClick={() => setOpen(o => !o)} aria-label="Menu" aria-expanded={open} data-testid="public-header-menu-toggle">
                        {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
                    </button>
                </div>
            </div>
            {open && (
                <nav className="lg:hidden border-t border-line bg-white px-6 py-3 grid" data-testid="public-header-mobile-nav" aria-label="Mobile">
                    {[...NAV, { to: "/faq", label: "FAQ" }, { to: "/login", label: "Sign in" }].map(n => (
                        <NavLink key={n.to} to={n.to} onClick={() => setOpen(false)} className={({ isActive }) => `py-3 border-b border-line last:border-0 text-sm ${isActive ? "text-klein" : ""}`}
                            data-testid={`mobile-nav-${n.to.slice(1)}`}>{n.label}</NavLink>
                    ))}
                </nav>
            )}
        </header>
    );
}
